import React from 'react';
import Loader from 'react-loader-spinner';
import { usePromiseTracker } from "react-promise-tracker";

const LoadingIndicator = (props) => {
    const { promiseInProgress } = usePromiseTracker();

    return promiseInProgress &&
        <div className="pagi-overlay" style={{
                width: "100%",
                height: "100",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "fixed",
                background: "rgb(0,0,0,1)",
                bottom: "0",
                zIndex:"9",
                padding:"10px"
                  }}>
            <Loader type="Oval" color="#17b81c" height="40" width="40" />
        </div>
};

export default LoadingIndicator;